import axios from "axios"


function getSkillSets() {
    return axios.get(`/api/v1/user/skill-sets`)
}

function markSkillSetEvolutionAsRead({}, values) {
    return axios.post(`/api/v1/user/skill-sets/read`, values)
}

function getStripeFormUrl({}, {}, params) {
    return axios.get(`/api/v1/user/stripe-form-url`, {params})
}

function getDashboardExpressUrl({}, {}, params) {
    return axios.get(`/api/v1/user/dashboard-express-url`, {params})
}


export const skillSetsService = {
    getSkillSets,
    markSkillSetEvolutionAsRead,
    getStripeFormUrl,
    getDashboardExpressUrl
}

